import { createFileRoute } from '@tanstack/react-router';
import { ActivityFeed } from '@/components/activity/activity-feed';
import { usePageTitle } from '@/hooks/usePageTitle';

function ActivityPage() {
  usePageTitle('Activity');
  return <ActivityFeed />;
}

export const Route = createFileRoute('/dashboard/activity')({
  component: ActivityPage,
});
